// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.snt-salepage-action.v-list[data-v-6c47dde6]  {\n  /* border-radius: 14px; */\n  background: #ffffff;\n}\n.snt-salepage-action__menu[data-v-6c47dde6] {\n  box-shadow: none;\n}\n.snt-salepage-action__btn.v-btn[data-v-6c47dde6] {\n  background: #ffffff;\n  min-width: 32px;\n  padding: 0;\n}\n.snt-salepage-action .v-list-item__subtitle[data-v-6c47dde6] {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  color: #6B6B6B;\n}\n", ""]);
// Exports
module.exports = exports;
